import React from 'react';
import { useSnackbar } from 'notistack';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

const SnackbarAction = ({ keyProp }) => {
  const { t } = useTranslation();
  const { closeSnackbar } = useSnackbar();

  return (
    <Button onClick={() => closeSnackbar(keyProp)}>{t('shared.SnackbarAction.dismiss')}</Button>
  );
};

export default SnackbarAction;
